import Layout from '@/components/Layout';
import LoginPage from '@/login/LoginPage';
import JoinPage from '@/join/JoinPage';
import AuthPage from '@/auth/AuthPage';
import TeamMembersPage from '@/team-members/TeamMembersPage';
import HomePage from '@/home/HomePage';
import DemandPage from '@/demand/DemandPage';
import ProjectPage from '@/project/ProjectPage';
import DeliveryPage from '@/delivery/DeliveryPage';
import BugPage from '@/bug/BugPage';

export default [
  {
    path: '',
    name: 'app',
    element: <Layout.Blank />,
    children: [
      {
        path: '/login',
        name: 'app.login',
        element: <LoginPage />,
      },
      {
        path: '/join',
        name: 'app.join',
        element: <JoinPage />,
      },
      {
        path: '/auth',
        name: 'app.auth',
        element: <AuthPage />,
      },
      {
        path: '',
        name: 'abstract',
        element: <Layout.Basic />,
        children: [
          {
            path: '/',
            name: 'app.redirect',
            redirect: '/home',
          },
          {
            path: '/home',
            name: 'app.home',
            element: <HomePage />,
          },
          {
            path: '/demand',
            name: 'app.demand',
            element: <DemandPage />,
          },
          {
            path: '/project',
            name: 'app.project',
            element: <ProjectPage />,
          },
          {
            path: '/delivery',
            name: 'app.delivery',
            element: <DeliveryPage />,
          },
          {
            path: '/bug',
            name: 'app.bug',
            element: <BugPage />,
          },
          {
            path: '/team-members',
            name: 'app.teamMembers',
            element: <TeamMembersPage />,
          },
        ],
      },
    ],
  },
];
